<template>
    <div v-if="bigImage != null" class="ii-modal-bg" v-on:click="hideBigImage">
        <div class="image-container" v-if="bigImage.id != -1">
            <img v-bind:src="'/api/images/' + bigImage.id + '/file'">
        </div>
        <button class="modal-close is-large" aria-label="close"></button>
        <button class="icon-only-button next" v-on:click.stop="nextBigImage"><i class="im im-angle-right"></i></button>
        <button class="icon-only-button previous" v-on:click.stop="previousBigImage"><i class="im im-angle-left"></i></button>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        computed: mapState(["bigImage", "imagesById"]),
        data() {
            return {}
        },
        methods: {
            ...mapActions(["hideBigImage", "nextBigImage", "previousBigImage"]),
            getImgClasses() {
                if(!this.bigImage) {
                    return {};
                }
                switch(this.bigImage.orientation) {
                    case "Rotate 90 CW":
                        return {
                            rotate: true,
                            right: true
                        }
                    case "Rotate 270 CW":
                        return {
                            rotate: true,
                            left: true
                        }
                    default:
                        return {
                            
                        }
                }
            },
        }
    }
</script>